import { useEffect, useState } from "react";
import { authApi } from "@/lib/api";

/** Loads password requirement text from GET /auth/password-policy (backend is source of truth). */
export function usePasswordPolicyHint() {
  const [hint, setHint] = useState("");
  useEffect(() => {
    let cancelled = false;
    authApi.passwordPolicy()
      .then((data) => {
        if (!cancelled && data?.message) setHint(data.message);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return hint;
}
